import { Header } from '@/features/availability/components/Header';
import LogoOnPage from '@/assets/img/logo-on-page.png';
import { Button } from '@/components/Elements/Button';
import { SimpleHeader } from '@/features/availability/components/SimpleHeader';
import './VerifyOtp.scss'
export type Props = {
  onClickBtn: (type: any) => void;
  onBackClick:()=>void;
};
export const Profile = ({ onClickBtn,onBackClick }: Props) => {
  return (
    <div>
      <SimpleHeader
        onBackClick={() => {
          onBackClick();
        }}
        
        screenTitle={"Profile"}
      />
      <div className="profile-page-cotent-title">Hello</div>
      <div className="profile-page-text">Let’s get you started</div>
      <img alt="back" src={LogoOnPage} className="logo-page" />
      <Button
        type="button"
        variant="primary"
        onClick={() => {
          onClickBtn(1);
        }}
        className="justify-center rounded-md border profile-new-btn"
      >
        REGISTER
      </Button>
      <Button
        type="button"
        variant="inverse"
        onClick={() => {
          onClickBtn(2);
        }}
        className="justify-center rounded-md border profile-new-btn"
      >
        LOG IN
      </Button>
      <div className='already-login forgot-pass'>
        <a
          onClick={() => {
            onClickBtn(-2);
          }}
          className="link"
        >
          FORGOT PASSWORD
        </a>
      </div>
    </div>
  );
};
